import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { UserCredentials } from './user-credentials';
import { UserCredentialsCognito } from './user-credentials-cognito';
import { UserCredentialsLDAP } from './user-credentials-ldap';

@Injectable()
export class JWTService {
    private credentialsMode: 'COGNITO' | 'LDAP';;
    private userCredentialsCognito: UserCredentialsCognito;
    private userCredentialsLDAP: UserCredentialsLDAP;

    constructor(
        private appConfig: AppConfig,
        private http: HttpClient,) {
        const tenantInfo = this.appConfig.getTenantInfo();
        this.credentialsMode = tenantInfo.loginStrategy || 'COGNITO';
        if (window.sessionStorage.getItem('initiatingSAMLLogin')) {
            this.credentialsMode = 'COGNITO';
        }
        this.userCredentialsCognito = new UserCredentialsCognito(appConfig);
        this.userCredentialsLDAP = new UserCredentialsLDAP(appConfig, http);
    }

    async getAccessToken(): Promise<string> {
        if (this.credentialsMode === 'COGNITO') {
            return this.userCredentialsCognito.getAccessToken();
        } else {
            return this.userCredentialsLDAP.getAccessToken();
        }
    }

    async getIdToken(): Promise<string> {
        if (this.credentialsMode === 'COGNITO') {
            return this.userCredentialsCognito.getIdToken();
        } else {
            return this.userCredentialsLDAP.getIdToken();
        }
    }

    getUserCredentials(): UserCredentials {
        if (this.credentialsMode === 'COGNITO') {
            return this.userCredentialsCognito;
        } else {
            return this.userCredentialsLDAP;
        }
    }

    setCredentialsMode(mode: 'COGNITO' | 'LDAP') {
        this.credentialsMode = mode;
    }

}
